import request from "@/utils/oms-request";
import download from "@/utils/oms-download";
import qs from "qs";

// 查询客人品牌
export const queryCustomerBrands = (params) =>
    request({
        url: `/packaging/brands`,
        method: "get",
        params,
    });

export const pageQueryPackagingByBrand = (params) =>
    request({
        url: `/packaging`,
        method: "get",
        params,
    });

// 客人包装维护模版导出
export const downloadTemplate = () =>
    download({
        responseType: "blob",
        url: `/packaging/download-template`,
        method: "get",
    });

// 客人包装管理信息下载
export const downloadInfo = (params) =>
    download({
        responseType: "blob",
        url: `/packaging/download`,
        method: "get",
        params
    })

// 上传维护客人包装
export const uploadCustomerPackage = (params, data: FormData) =>
    request({
        headers: { "Content-Type": "multipart/form-data" },
        url: `/packaging/upload`,
        method: "put",
        params,
        data: data,
    })

export const updatePackaging = (data) =>
    request({
        url: `/packaging`,
        method: "put",
        data,
    });

export const deletePackaging = (params) =>
    request({
        url: `/packaging`,
        method: "delete",
        params,
    });

export const purgeAllPackagingByBrand = (params) =>
    request({
        url: `/packaging/all`,
        method: "delete",
        params,
    })

// pi包装列表
export const queryPiPackaging = (params) =>
    request({
        url: `/packaging/pi`,
        method: "get",
        params,
    });

export const downloadPiPackaging = (id) =>
    download({
        responseType: "blob",
        url: `/packaging/pi/${id}/download`,
        method: "get",
    });

// pi匹配到包装的详情下载
export const downloadPiMatchedPackagingDetail = (id, params) =>
    download({
        responseType: "blob",
        url: `/packaging/pi/${id}/detail/download`,
        method: "get",
        params,
    })

// pi包装中下载后变更的数量
export const getChecksumChangedCount = () =>
    request({
        url: `/packaging/pi/checksum-changed-count`,
        method: "get",
    });

// pi包装列表详情头部信息
export const detailQueryPiPackagingDetailHeadInfo = (id) =>
    request({
        url: `/packaging/pi/${id}/detail-head-info`,
        method: "get",
    });

// pi未匹配到的包装列表详情
export const pageQueryPiUnmatchedPackagingDetail = (id, params) =>
    request({
        url: `/packaging/pi/${id}/unmatched-details`,
        method: "get",
        params,
    });

// pi未匹配到的包装列表下载
export const downloadPiUnmatched = (id: string) =>
    download({
        responseType: "blob",
        url: `/packaging/pi/${id}/download/unmatched`,
        method: "get",
    });

// pi匹配到的包装列表详情
export const pageQueryPiMatchedPackagingDetail = (id, params) =>
    request({
        url: `/packaging/pi/${id}/matched-details`,
        method: "get",
        params,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    });

// pi包装统计
export const listQueryPiMatchedPackagingStatistics = (id) =>
    request({
        url: `/packaging/pi/${id}/matched-packaging-statistics`,
        method: "get",
    })

// 包装提供方枚举
export const getPackagingProviders = () =>
    request({
        url: `/packaging/packaging-providers`,
        method: "get",
    });
